import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/PromoDiaDasMulheres";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/promo-dia-das-mulheres")({
  head: () =>
    pageHead({ title: "Ação Mês das Mulheres | Clara Camille", path: "/promo-dia-das-mulheres", noindex: true }),
  component: Page,
});
